<template>
  <div>
    <!-- TOP PANEL -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <h2 v-if="client.firstName" class="title">Olá {{client.firstName}}, bem vindo de volta!</h2>
        <h2 v-if="!client.firstName" class="title">Bem vindo à iSET</h2>
        <h5 v-if="!client.firstName" class="description mobile-hidden">
          A plataforma de e-commerce mais livre, flexível, eficiente e estável para sua loja virtual!
        </h5>
      </div>      
    </div>    
    <!-- END TOP PANEL -->

    <div class="md-layout">
      <!-- LEFT PANEL -->
      
      <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">      
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-warning">
            <div class="card-icon">
              <md-icon>store</md-icon>
            </div>
            <h4 class="title">Acesse sua Loja Virtual</h4>
          </md-card-header>
          <md-card-content>
              <h5>Informe o endereço de sua loja virtual</h5>
              <ValidationObserver ref="form">
                <form @submit.prevent="submit()">
                  <ValidationProvider
                    name="domain"
                    :rules="{
                      required: true, 
                      regex: /^((\w{3,}\:\/\/)?(\w*\.)?[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9])\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,})?$/
                    }"
                    v-slot="{ passed, failed }"
                  >
                    <md-field 
                      :class="[
                        { 'md-error': failed },
                        { 'md-valid': passed },
                        { 'md-form-group': true }
                      ]"
                    >
                      <md-icon>language</md-icon>
                      <label>Domínio da loja virtual</label>
                      <md-input v-model="ecommercePanel.serviceDomain" @keyup="validate" autocomplete="domain" type="text" :placeholder="domainExample"></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>

                    </md-field>              
                  </ValidationProvider>  
                </form>
              </ValidationObserver>            

              <CollapseContent :active="domain.base != ''">
                <template slot="md-collapse-content">
                  <ul>
                    <li>
                      <b>Link temporário: </b>
                      <a :href="ecommercePanel.tempURL" @click="catalogClick" target="_blank">{{ecommercePanel.tempURL}}</a>
                    </li>
                    
                    <li v-if="ecommercePanel.login">
                      <b>Login: </b>
                      <span>{{ecommercePanel.login}}</span>
                    </li>

                    <li v-if="ecommercePanel.password">
                      <b>Senha: </b> 
                      <a href="#" @click="togglePwd" v-if="userCreated && !showPwd">******** (mostrar senha)</a>
                      <a href="#" @click="togglePwd" v-if="userCreated && showPwd">{{ecommercePanel.password}} (esconder senha)</a>
                    </li>

                    <p><small>Para acessar o painel administrativo, basta adicionar /admin ao final do link</small></p>
                    <p v-if="!ecommercePanel.login"><small>Caso você não saiba o login de sua loja, você pode entrar em contato com nosso atendimento usando o chat online nessa página.</small></p>
                  </ul>            
                </template>
              </CollapseContent>
          </md-card-content>
          <md-card-actions>
            <CollapseContent :active="domain.base != ''">
              <template slot="md-collapse-content">                 
                <a :href="ecommercePanel.tempCatalogLink" @click="catalogClick" target="_blank"><md-button class="md-warning slim-button inverted">Catálogo</md-button></a>
                <a :href="ecommercePanel.tempAdminLink" @click="adminClick" target="_blank"><md-button class="md-warning slim-button">Painel Admin<span class="mobile-hidden">istrativo</span></md-button></a>
              </template>
            </CollapseContent>
          </md-card-actions>
        </md-card>

      </div>
      <!-- END LEFT PANEL-->


      <!-- RIGHT PANEL -->
      <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">
        
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>support</md-icon>
            </div>
            <h4 class="title">Primeiros Passos</h4>
          </md-card-header>
          <md-card-content>            
            <h5>Não perca tempo!</h5>
            <p>Inicie agora mesmo seu <b>TREINAMENTO GRATUITO</b>. Assista aos vídeos quando quiser e marque reuniões com nossos especialistas.</p>
            <a :href="supportPanel.trainingLink" @click="trainingClick" target="_blank"><img src="/img/banner-onboarding.png"/></a>            
          </md-card-content>
          <md-card-actions>
            <a :href="supportPanel.helpLink" @click="helpClick" target="_blank"><md-button class="md-info slim-button inverted mobile-hidden">Acessar os Tutoriais</md-button></a>
            <a :href="supportPanel.trainingLink" @click="trainingClick" target="_blank"><md-button class="md-info slim-button">Inicie seu Treinamento</md-button></a>
          </md-card-actions>
        </md-card>

      </div>
      <!-- END RIGHT PANEL -->
    </div>

    <!-- BOTTOM PANEL -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto">
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>support</md-icon>
            </div>
            <h4 class="title">Obtenha Ajuda</h4>
          </md-card-header>
          <md-card-content>

            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <ul>
                  <li><a :href="supportPanel.helpLink" @click="helpClick" target="_blank">Tutoriais em texto e vídeo</a></li>
                  <li><a :href="supportPanel.youtubeLink" @click="socialClick" target="_blank">Youtube da iSET</a></li>
                  <li><a :href="supportPanel.blogLink" @click="socialClick" target="_blank">Blog da iSET</a></li>
                </ul>
                <ul>
                  <li><a :href="customerPanel.clientareaLink" @click="clientareaClick" target="_blank">Central do Cliente</a></li>                  
                  <li><a :href="customerPanel.ticketsLink" @click="clientareaClick" target="_blank">Suporte via ticket</a></li>
                </ul>
                <ul>
                  <li><a href="https://api.whatsapp.com/send?phone=5531983480703&text=Ol%C3%A1!+Preciso+falar+com+a+equipe+comercial&utm_source=Wpp&utm_medium=Ajuda&utm_campaign=comercial_wpp_ajuda_novo" @click="helpClick" target="_blank">Fale com um consultor comercial</a></li>
                </ul>
                <p><small>Para acessar a <a :href="customerPanel.clientareaLink" @click="clientareaClick" target="_blank">central do cliente</a>, utilize o mesmo e-mail e senha que você utilizou em seu cadastro.</small></p>
              </div>
              <div class="md-layout-item md-size-35 md-small-size-100 mx-auto text-center">
                <a href="https://bit.ly/3NJtphD" @click="socialClick">
                  Nossa Comunidade
                  <img src="/img/qrcode-wpp-comunidade.jpeg" style="max-height: 250px; width: auto;"/>
                </a>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-100 mx-auto text-center">
                <a href="https://api.whatsapp.com/send?phone=5531983287098&text=Ol%C3%A1,%20tudo%20bem?%20Tenho%20uma%20duvida,%20voc%C3%AA%20poderia%20me%20ajudar?%20" @click="helpClick">
                  Suporte via WhatsApp
                  <img src="/img/qrcode-wpp-suporte.svg" style="max-height: 230px; width: auto; margin-top: 10px;"/>
                </a>
              </div>
            </div>
            <p><small><b>Confira seu e-mail {{ client.email }}:</b><br/>Enviamos e-mail com informações de ativação, acesso e primeiros passos de sua loja. Caso não seja você que irá configurar a loja virtual, por favor encaminhe para a pessoa responsável. Aproveite e adicione a iSET em sua lista de contatos para receber todas as nossas comunicações.</small></p>
          </md-card-content>
        </md-card>          
      </div>      
    </div>    
    <!-- END BOTTOM PANEL -->

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { SlideYDownTransition } from "vue2-transitions";
import { CollapseContent } from '@/components';
import Domain from '../Domain.js'
//import {} from '@/components'

export default {
  components: {    
    SlideYDownTransition,
    CollapseContent
  },

  data() {
    return {      
      session: this.$store.state.session,
      client: this.$store.state.client,
      business: this.$store.state.business,
      address: this.$store.state.address,
      domain: this.$store.state.domain,
      plan: this.$store.state.plan,
      order: this.$store.state.order,      
      hosting: this.$store.state.hosting,      
      ecommerce: this.$store.state.ecommerce,
      invoice: this.$store.state.invoice,

      paymentUrl: "https://ica.iset.com.br/modules/gateways/paghiper_pix.php?invoiceid="+this.$store.state.invoice.id+"&uuid="+this.$store.state.client.id+"&mail="+this.$store.state.client.email+"&pix=true",
      invoiceUrl: "https://ica.iset.com.br/viewinvoice.php?id="+this.$store.state.invoice.id+"&access_token="+this.$store.state.client.access_token,
      // invoiceUrl: this.$store.state.invoice.url,

      showPwd: false,
      userCreated: this.$store.state.ecommerce.userCreated,
      
      nextSteps: {
        domainRegister:       this.$store.state.domain.status == "available",
        ecommerceFail:        this.$store.state.ecommerce.status != "Active",
        hostingFail:          this.$store.state.hosting.id > 0 && this.$store.state.order.hosting == true && this.$store.state.hosting.status != "Active",
        ecommerceInfo:        true,
        inboxInfo:            true,
        trainingInfo:         true,
        emailInfo:            this.$store.state.hosting.id > 0,
        subdomainInfo:        this.$store.state.domain.subdomain != "" && this.$store.state.domain.subdomain != "www",
        externalHostingInfo:  !this.$store.state.hosting.id > 0,
        domainInfo:           this.$store.state.hosting.id > 0 && this.$store.state.order.hosting == true && this.$store.state.domain.status != "available",
      },      

      ecommercePanel: {
        domainValid: false,
        serviceDomain: this.$store.state.domain.base ? (this.$store.state.domain.subdomain ? this.$store.state.domain.subdomain + "." : "www.") + this.$store.state.domain.base + "." + this.$store.state.domain.extension : "",
        finalURL: this.$store.state.domain.protocol + "://" + (this.$store.state.domain.subdomain ? this.$store.state.domain.subdomain + "." : "www.") + this.$store.state.domain.base + "." + this.$store.state.domain.extension,
        tempURL: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain,
        login: this.$store.state.client.email,
        password: this.$store.state.password,
        tempCatalogLink: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain,
        tempAdminLink: this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain + "/admin" + (this.$store.state.ecommerce.userToken ? '/?token=' + this.$store.state.ecommerce.userToken : ''),
      },

      supportPanel: {        
        helpLink: "https://ajuda.iset.com.br",
        helpDomain: "https://help.iset.com.br/dominios-conectar/",
        helpDNS: "https://help.iset.com.br/dns-no-registro-br/",
        helpCNAME: "https://help.iset.com.br/vinculandoo-dominio-registrobr/",
        helpEmail: "https://help.iset.com.br/criar-conta-de-e-mail/",
        trainingLink: "https://ajuda.iset.com.br/inicio/por-onde-comecar",
        youtubeLink: "https://www.youtube.com/isetbrasil",
        blogLink: "https://www.iset.com.br/blog",
      },

      hostingPanel: {
        cpanelLink: this.$store.state.domain.protocol + "://cpanel." + this.$store.state.domain.base + "." + this.$store.state.domain.extension,
        cpanelDirectLink: "https://ica.iset.com.br/clientarea.php?action=productdetails&id="+ this.$store.state.hosting.id +"&dosinglesignon=1",
        emailsLink: "https://ica.iset.com.br/?m=iset_emails",
        domainRegisterLink: "https://meunegocio.uol.com.br/lp/dominios/iset",
      },

      customerPanel: {
        clientareaLink: "https://ica.iset.com.br/",
        ticketsLink: "https://ica.iset.com.br/submitticket.php",
      },

    };
  },
  
  computed:{
    domainExample() { 
      return "ex: www." + this.$store.state.tempDomain;
    },
  },
  
  methods: {
    catalogClick(){     this.updateClick('catalog'); },
    adminClick(){       this.updateClick('admin'); },
    helpClick(){        this.updateClick('help'); },
    trainingClick(){    this.updateClick('training'); },
    hostingClick(){     this.updateClick('hosting'); },
    socialClick(){      this.updateClick('social'); },
    clientareaClick(){  this.updateClick('ica'); },
    invoiceClick() {    this.updateClick('invoice'); },

    togglePwd(){
      this.showPwd = !this.showPwd;
    },

    validate() {
      this.$debug('Domain => validate');

      this.$store.commit('domain', ['subdomain', '']);
      this.$store.commit('domain', ['base', '']);
      this.$store.commit('domain', ['extension', '']);

      return this.$refs.form.validate().then(res => {        
        this.ecommercePanel.domainValid = res;
        if (res) this.checkDomain();
        return res;
      });      
    },

    checkDomain(){
      const domain = new Domain(this.ecommercePanel.serviceDomain);
      this.$debug('Domain => checkDomain: ' + this.ecommercePanel.serviceDomain);

      const parts  = domain.parts();
      if(!parts.base || !parts.extension) return;
      this.$store.commit('domain', ['subdomain', parts.subdomain]);
      this.$store.commit('domain', ['base', parts.base]);
      this.$store.commit('domain', ['extension', parts.extension]);

      this.$debug('Domain => subdomain: ' + this.$store.state.domain.subdomain);
      this.$debug('Domain => base: ' + this.$store.state.domain.base);
      this.$debug('Domain => extension: ' + this.$store.state.domain.extension);

      this.ecommercePanel.serviceDomain = this.$store.state.domain.base ? (this.$store.state.domain.subdomain ? this.$store.state.domain.subdomain + "." : "www.") + this.$store.state.domain.base + "." + this.$store.state.domain.extension : "";
      this.ecommercePanel.finalURL = this.$store.state.domain.protocol + "://" + (this.$store.state.domain.subdomain ? this.$store.state.domain.subdomain + "." : "www.") + this.$store.state.domain.base + "." + this.$store.state.domain.extension;
      this.ecommercePanel.tempURL = this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain;
      this.ecommercePanel.tempCatalogLink = this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain;
      this.ecommercePanel.tempAdminLink = this.$store.state.tempProtocol + "://" + this.$store.state.domain.base + "." + this.$store.state.tempDomain + "/admin" + (this.$store.state.ecommerce.userToken ? '/?token=' + this.$store.state.ecommerce.userToken : '');

      this.$debug('ecommercePanel => serviceDomain: ' + this.ecommercePanel.serviceDomain);
      this.$debug('ecommercePanel => finalURL: ' + this.ecommercePanel.finalURL);
      this.$debug('ecommercePanel => tempURL: ' + this.ecommercePanel.tempURL);
      this.$debug('ecommercePanel => tempCatalogLink: ' + this.ecommercePanel.tempCatalogLink);
      this.$debug('ecommercePanel => tempAdminLink: ' + this.ecommercePanel.tempAdminLink);

    },

    updateClick(option){
      this.$debug("Finished => updateClick: " + option);
      const field = "pressed_" + option;

      const params = {'id'    : this.$store.state.session.id,
                      'email' : this.$store.state.client.email,                      
                      [field] : 1 };
      this.$functions.addTrack(params);
    },

    async createUser(){
      this.$debug('Finished => createUser');      

      const params = {'serviceid':  this.ecommerce.id,
                      'domain':     this.domain.base + "." + this.$store.state.tempDomain,
                      'name':       this.client.firstName,
                      'email':      this.client.email, 
                      'cellphone':  this.client.phone, 
                      'password':   this.$store.state.password };

      this.$debug('CREATE USER');
      let result = await this.$functions.post('createUser', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          this.$store.commit('ecommerce', ['userCreated', true]);
          this.$store.commit('ecommerce', ['userToken', response.token]);
        } else {
          this.$debug(response.message);
          return response.message;
        }
      });

      return result;
    },


  },

}
</script>

<style lang="scss">
@import "../assets/scss/activation.scss";

h2{
  margin-top: 0px;
}

.md-card-actions{
  padding-top: 20px !important;
}

.bg-top{
  display: none;
}

.payment-pix{
  height: 480px;
  overflow: hidden;
}
.payment-pix iframe{
  height: 480px;
  border: none;
}

.wellcome-video {
  height: 340px !important;
}

.md-card-content p{
  font-size: 1rem;
}

.info-card.payment li{
  list-style-type: none;
}

.next-steps{
  margin-top: 0;
}

.next-steps .timeline.timeline-simple:before{
  background-color: $gray !important;
  opacity: 0.2;
}

.next-steps .timeline .timeline-panel{
  padding: 10px !important;
}

.next-steps .timeline .timeline-footer p{
  font-size: 12px;
  text-transform: none;
  margin: 0px;
}

.next-steps .timeline .dropdown-toggle.md-button {  
  line-height: 1;
  font-size: 12px;
  font-weight: 400;
}
.next-steps .timeline .dropdown-toggle.md-button .md-ripple{
  padding: 7px 20px !important;
}

.onboarding-container{
  width: 598px !important;
  height: 322px !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  overflow: hidden !important;
}

.onboarding-container ._vs_ictr_player{
  width: 100% !important;
  height: 100% !important;
}

.onboarding-container ._vs_ictr_player-wrapper{
  width: 100% !important;
  height: 100% !important;
}

@media only screen and (max-width: 1200px) {
  .onboarding-container{
    width: 490px !important;
    height: 270px !important;
  }
}

@media only screen and (max-width: 992px) {
  .onboarding-container{
    width: 345px !important;
    height: 186px !important;
  }
}

@media only screen and (max-width: 960px) {
  .onboarding-container{
    width: 640px !important;
    height: 345px !important;
  }
}

@media only screen and (max-width: 767px) {
  .onboarding-container{
    width: 440px !important;
    height: 227px !important;
  }
}

@media only screen and (max-width: 480px) {
  .onboarding-container{
    width: 320px !important;
    height: 180px !important;
  }
}
</style>
